export var mutations = {
    setUserBetas: function (state, payload) {
        state.userBetas = payload;
    },
    setLoading: function (state, payload) {
        state.loading = payload;
    },
};
